import { Card, CardBody } from 'reactstrap';

import { SeedingBacteriaList } from './SeedingBacteriaList';

import styles from './Seeding.module.scss';
import { ProcessedBacteriaData } from 'services/seeding/seedingResponses';

type SeedingBacteriaProps = {
  data: ProcessedBacteriaData[];
  transferredFromBirthMother?: boolean;
};

export const SeedingBacteria = ({
  data,
  transferredFromBirthMother,
}: SeedingBacteriaProps) => {
  return (
    <Card className={styles.seedingContainer}>
      <CardBody className={styles.wider}>
        <h5>Species Detail</h5>
        {data && (
          <SeedingBacteriaList
            data={data}
            transferredFromBirthMother={transferredFromBirthMother}
          />
        )}
      </CardBody>
    </Card>
  );
};
